import { action, computed, observable } from 'mobx';
import { RemoteResourceV2, updateRemoteResourceV2 } from '../../../../commonv2/api/RemoteResourceV2';
import { EventDetails, EventId, EventChargeScope } from '../../../types/event';
import { EventApis } from '../../../api/event';
import { UserEventReservationApis } from '../../../api/user';
import { CurrentUserState } from '../../../states/CurrentUserState';
import { TokenType } from '../../../../commonv3/types/tokens';

export class DetailsPageState {
    @observable eventId: EventId;
    @observable event: RemoteResourceV2<EventDetails> = RemoteResourceV2.loading();
    @observable alreadyReserved: boolean = false;
    @observable membershipAvailable: boolean = false;

    @computed
    get appliedPaymentType() {
        if (this.event.isEmpty() || this.event.get().charge_scope === EventChargeScope.ALL_USERS) {
            return 'credit_card';
        }
        return this.membershipAvailable ? 'token' : 'credit_card';
    }

    @computed
    get appliedPrice() {
        if (this.event.isEmpty() || this.appliedPaymentType === 'token') {
            return 0;
        }
        return this.event.get().price;
    }

    @action
    async init(eventId: EventId, userState: CurrentUserState) {
        this.eventId = eventId;
        const event = await updateRemoteResourceV2(
            this.event,
            (v) => (this.event = v),
            () => EventApis.find(this.eventId)
        );
        await userState.reloadUser();

        if (userState.isSignedIn()) {
            const userReservations = await UserEventReservationApis.findAll();
            this.alreadyReserved =
                userReservations.find((r) => r.event_type === 'Event' && r.event_id === this.eventId) != null;
            if (event) {
                this.membershipAvailable =
                    userState.availableTokens.findAffordableToken(TokenType.EVENT, 1, event.starts_at) != null;
            }
        }
    }
}
